import { render, staticRenderFns } from "./insuranceOrder.vue?vue&type=template&id=4a7d4211&scoped=true"
import script from "./insuranceOrder.vue?vue&type=script&lang=js"
export * from "./insuranceOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7d4211",
  null
  
)

export default component.exports